export default {
  analytics: 'Стран: {countries} | Групп: {groups} | Операторов: {operators}',

  hints: {
    tree: {
      country: 'страна',
      operator: 'оператор',
      group: 'группа',
      groupsCount: 'Групп: {groups}',
      operatorsCount: 'Операторов: {operators}',
      mcc: 'MCC',
      mnc: 'MNC'
    }
  },

  snackbars: {
    created: 'Группа создана',
    updated: 'Группа обновлена',
    removed: 'Группа удалена'
  },

  contents: {
    confirm: {
      remove: 'Вы уверены что хотите удалить группу {title}?'
    }
  },

  tabs: {
    all: 'Все',
    checked: 'Выбранные'
  },

  pills: {
    all: 'Доступные',
    checked: 'Выбранные'
  },

  errors: {
    mccmnc: {
      dictionary: 'Словарь для MCC/MNC не найден.<br>Пожалуйста, обратитесь к администратору.'
    }
  }
}
